"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _SubNav = _interopRequireDefault(require("../../components/SubNav/SubNav.js"));
var _PaperSubNavData = require("./data/PaperSubNav.data.js");
var _linksHelper = require("../../utils/linksHelper.js");
const PaperSubNav = _ref => {
  let {
    tenant,
    onSearch,
    cartCount,
    draftCount,
    isUserLoggedIn,
    MenuItemComponent,
    trackMenuInteraction,
    trackProductsSearched,
    trackSearchInitialized,
    withExperiment,
    additionalLink,
    searchBarPlaceholder,
    flags = {},
    menuTreeData
  } = _ref;
  let links;
  if (tenant === 'tk') {
    links = (0, _linksHelper.transformTree)(menuTreeData);
  } else {
    links = (0, _linksHelper.filterLinksByFeatureFlag)(_PaperSubNavData.wwLinks, flags);
  }
  const subNavButtons = tenant === 'tk' ? _PaperSubNavData.tkSubNavButtons : _PaperSubNavData.wwSubNavButtons;
  const iconLinks = tenant === 'tk' ? (0, _PaperSubNavData.buildTKIconLinks)(isUserLoggedIn, cartCount, draftCount) : (0, _PaperSubNavData.buildWWIconLinks)(isUserLoggedIn, cartCount);
  return /*#__PURE__*/_react.default.createElement(_SubNav.default, {
    tenant: tenant,
    onSearch: onSearch,
    links: links,
    subNavButtons: subNavButtons,
    rightSideLinks: iconLinks,
    searchBarPlaceholder: searchBarPlaceholder || 'Search rustic, modern, floral and more!',
    MenuItemComponent: MenuItemComponent,
    trackMenuInteraction: trackMenuInteraction,
    trackProductsSearched: trackProductsSearched,
    trackSearchInitialized: trackSearchInitialized,
    withExperiment: withExperiment,
    additionalLink: additionalLink
  });
};
var _default = exports.default = PaperSubNav;